<template lang="pug">
  .b-file-list
    ._items-zoomed(v-if="itemsZoomed.length")
      FileTile._item(
        v-for="item in itemsZoomed"
        :key="item.id"
        :file="item.file"
        :error="item.error"
        :process="item.process"
        :progress="item.progress"
        :removable="item.removable"
        :selectable="item.selectable"
        :selected="item.selected"
        :xl="zoomed"
        :zoomable="zoom"
        @preview="setViewedImage(item)"
        @remove="$emit('remove', item)"
        @toggle="$emit('toggle', item)"
        @zoom="setZoomed"
      )
    ._items
      FileTile._item(
        v-for="item in itemsNotZoomed"
        :key="item.id"
        :file="item.file"
        :error="item.error"
        :process="item.process"
        :progress="item.progress"
        :removable="item.removable"
        :selectable="item.selectable"
        :selected="item.selected"
        :zoomable="zoom"
        @preview="setViewedImage(item)"
        @remove="$emit('remove', item)"
        @toggle="$emit('toggle', item)"
        @zoom="setZoomed"
      )
      a._dl-all(v-if="downloadAll && files.length > 1" :href="downloadAllHref")
    //._buttons(v-if="zoom")
      Btn(grey transparent narrow v-if="downloadAll && files.length > 1" :href="downloadAllHref") Скачать все
      Btn(grey transparent narrow v-if="files.length && zoom" @click="setZoomed(!zoomed)")
        Icon(:name="zoomed ? 'zoom-out' : 'zoom-in'")
        | {{ zoomed ? 'Уменьшить' : 'Увеличить' }} превью
      ._slot-buttons
        slot(name="buttons")
    BasePopup(
      :type="currPreview.info.type"
      v-if="currPreviewIndex !== null"
      :src="currPreview.file.url"
      :hasPrev="hasPrev"
      :hasNext="hasNext"
      @prev="setPrev"
      @next="setNext"
      @close="currPreviewIndex = null"
    )
</template>

<script>
import fileTypes from '@/utils/fileTypes';
import FileTile from '@/components/FileTile.vue';
import BasePopup from '@/components/BasePopup.vue';
import modelCustomSettings from '@/model/userCustomSettings';

export default {
  name: 'FileList',
  components: { FileTile, BasePopup },
  props: {
    files: Array,
    uploadingFiles: Array,
    downloadAll: Boolean,
    zoom: Boolean,
  },
  data() {
    return {
      currPreviewIndex: null,
    };
  },
  computed: {
    items() {
      // return this.files
      //   .map(f => ({
      //     ...f,
      //     info: fileTypes[f.file.extension],
      //   }));
      return this.files
        .map(f => ({
          ...f,
          info: f.file.extension === 'mov' && this.$store.state.auth?.user?.customSettings?.settings?.movPreviewEnabled
            ? { hasPreview: true, type: 'video' }
            : fileTypes[f.file.extension],
        }));
    },
    previews() {
      return this.items
        .filter(f => f.info?.hasPreview);
    },
    itemsZoomed() { return this.zoomed ? this.items.filter(p => p.info?.hasThumbnail) : []; },
    itemsNotZoomed() { return this.items.filter(i => !this.itemsZoomed.includes(i)); },
    zoomed() { return this.zoom && (this.$store.state.auth?.user?.customSettings?.imagePreviewXl ?? true); },
    currPreview() { return this.previews[this.currPreviewIndex]; },
    hasNext() { return this.currPreviewIndex < this.previews.length - 1; },
    hasPrev() { return this.currPreviewIndex > 0; },
    downloadAllHref() {
      const files = this.files.map((f) => `files[]=${f.file.id}`).join('&');
      return `/api/download?${files}`;
    },
  },
  methods: {
    setPrev() {
      if (this.hasPrev) {
        this.currPreviewIndex -= 1;
      }
    },
    setNext() {
      if (this.hasNext) {
        this.currPreviewIndex += 1;
      }
    },
    setViewedImage(file) {
      this.currPreviewIndex = this.previews.findIndex((i) => i.id === file.id);
    },
    setZoomed(imagePreviewXl) {
      console.log({ imagePreviewXl });
      modelCustomSettings.set({ imagePreviewXl });
    },
  },
};
</script>

<style scoped lang="scss">
.file-list {
  &__items {
    width: 100%;
    display: grid;
    grid-template-columns: repeat( auto-fill, minmax(82px, 1fr));
    align-items: center;
    grid-column-gap: 13px;
    grid-row-gap: 25px;
  }

  &__items-zoomed {
    display: grid;
    gap: 25px;
    margin-bottom: 30px;
  }

  //&__buttons {
  //  margin-top: 20px;
  //  display: flex;
  //  gap: 25px;
  //}
  //
  //&__slot-buttons {
  //  margin-left: auto;
  //}

  &__dl-all {
    position: relative;
    padding-bottom: 100%;
    margin-bottom: 40px;

    &:before {
      content: 'Скачать все';
      position: absolute;
      padding: 10px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      line-height: 15px;
      text-align: center;
      color: #92A0B0;
      border: 2px solid #92A0B0;
      box-sizing: border-box;
      border-radius: 10px;
    }
  }

  @media(max-width: 750px) {
    &__items {
      &.zoomed {
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  @media(max-width: 400px) {
    &__items {
      &.zoomed {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>
